module.exports = {
	colorData: () => {
		return [
			{
				'ESCAPE TITANIUM 4X4 FHEV': {
					Colors: [
						{
							Name: 'AZUL METÁLICO',
							NameAlt: 'AZUL METÁLICO',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/EscapeHibrida/AzulMetalico.webp'),
						},
						{
							Name: 'ROJO METÁLICO',
							NameAlt: 'ROJO METÁLICO',
							Hexa: '#AD0D27',
							HexaAlt: '#901025',
							Image: require('./../assets/Colores/EscapeHibrida/RojoMetalico.webp'),
						},
						{
							Name: 'GRIS CARBÓN',
							NameAlt: 'GRIS CARBÓN',
							Hexa: '#645D5D',
							HexaAlt: '#4B4746',
							Image: require('./../assets/Colores/EscapeHibrida/GrisCarbon.webp'),
						},
						{
							Name: 'PLATA PURO',
							Hexa: '#9C9DA1',
							HexaAlt: '#828486',
							Image: require('./../assets/Colores/EscapeHibrida/PlataPuro.webp'),
						},
						{
							Name: 'BLANCO PLATINO',
							Hexa: '#F0F0F0',
							HexaAlt: '#DBDBDB',
							Image: require('./../assets/Colores/EscapeHibrida/BlancoArtico.webp'),
						},
						{
							Name: 'NEGRO AGATA',
							NameAlt: 'NEGRO ÁGATA',
							Hexa: '#242424',
							HexaAlt: '#000000',
							Image: require('./../assets/Colores/EscapeHibrida/NegroAgata.webp'),
						},
					],
				},

				'ESCAPE ECOBOOST': {
					Colors: [
						{
							Name: 'ROJO METÁLICO',
							NameAlt: 'ROJO METÁLICO',
							Hexa: '#AD0D27',
							HexaAlt: '#901025',
							Image: require('./../assets/Colores/EscapeEcoboost/RojoLucido.webp'),
						},
						{
							Name: 'AZUL METÁLICO',
							NameAlt: 'AZUL METÁLICO',
							Hexa: '#7A849C',
							HexaAlt: '#686F88',
							Image: require('./../assets/Colores/EscapeEcoboost/AzulMetalico.webp'),
						},
						{
							Name: 'ARENA PERLADA',
							Hexa: '#ADA28F',
							HexaAlt: '#8F8878',
							Image: require('./../assets/Colores/EscapeEcoboost/ArenaPerlada.webp'),
						},
						{
							Name: 'NEGRO AGATA',
							NameAlt: 'NEGRO ÁGATA',
							Hexa: '#242424',
							HexaAlt: '#000000',
							Image: require('./../assets/Colores/EscapeEcoboost/NegroAgata.webp'),
						},
						{
							Name: 'GRIS MAGNETICO',
							NameAlt: 'GRIS MAGNÉTICO',
							Hexa: '#586066',
							HexaAlt: '#4C515A',
							Image: require('./../assets/Colores/EscapeEcoboost/GrisMagnetico.webp'),
						},
						{
							Name: 'PLATA SOLAR',
							Hexa: '#9EA4A9',
							HexaAlt: '#898B8F',
							Image: require('./../assets/Colores/EscapeEcoboost/Plata Solar.webp'),
						},
						{
							Name: 'BLANCO ARTICO',
							NameAlt: 'BLANCO ÁRTICO',
							Hexa: '#F0F0F0',
							HexaAlt: '#DBDBDB',
							Image: require('./../assets/Colores/EscapeEcoboost/BlancoArtico.webp'),
						},
					],
				},

				'ESCAPE SE 4X2 FHEV': {
					Colors: [
						{
							Name: 'AZUL METÁLICO',
							NameAlt: 'AZUL METÁLICO',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/EscapeSE/AzulMetalico.webp'),
						},
						{
							Name: 'ROJO METÁLICO',
							NameAlt: 'ROJO METÁLICO',
							Hexa: '#AD0D27',
							HexaAlt: '#901025',
							Image: require('./../assets/Colores/EscapeSE/RojoMetalico.webp'),
						},
						{
							Name: 'GRIS CARBÓN',
							NameAlt: 'GRIS CARBÓN',
							Hexa: '#645D5D',
							HexaAlt: '#4B4746',
							Image: require('./../assets/Colores/EscapeSE/GrisCarbon.webp'),
						},
						{
							Name: 'PLATA PURO',
							Hexa: '#9C9DA1',
							HexaAlt: '#828486',
							Image: require('./../assets/Colores/EscapeSE/PlataPuro.webp'),
						},
						{
							Name: 'BLANCO PLATINO',
							Hexa: '#F0F0F0',
							HexaAlt: '#DBDBDB',
							Image: require('./../assets/Colores/EscapeSE/BlancoPlatino.webp'),
						},
						{
							Name: 'NEGRO AGATA',
							NameAlt: 'NEGRO ÁGATA',
							Hexa: '#242424',
							HexaAlt: '#000000',
							Image: require('./../assets/Colores/EscapeSE/NegroAgata.webp'),
						},
					],
				},

				'ESCAPE SEL 4X2 FHEV': {
					Colors: [
						{
							Name: 'AZUL METÁLICO',
							NameAlt: 'AZUL METÁLICO',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/EscapeSEL/AzulMetalico.webp'),
						},
						{
							Name: 'ROJO METÁLICO',
							NameAlt: 'ROJO METÁLICO',
							Hexa: '#AD0D27',
							HexaAlt: '#901025',
							Image: require('./../assets/Colores/EscapeSEL/RojoMetalico.webp'),
						},
						{
							Name: 'GRIS CARBÓN',
							NameAlt: 'GRIS CARBÓN',
							Hexa: '#645D5D',
							HexaAlt: '#4B4746',
							Image: require('./../assets/Colores/EscapeSE/GrisCarbon.webp'),
						},
						{
							Name: 'PLATA PURO',
							Hexa: '#9C9DA1',
							HexaAlt: '#828486',
							Image: require('./../assets/Colores/EscapeSEL/PlataPuro.webp'),
						},
						{
							Name: 'BLANCO PLATINO',
							Hexa: '#F0F0F0',
							HexaAlt: '#DBDBDB',
							Image: require('./../assets/Colores/EscapeSEL/BlancoPlatino.webp'),
						},
						{
							Name: 'NEGRO AGATA',
							NameAlt: 'NEGRO ÁGATA',
							Hexa: '#242424',
							HexaAlt: '#000000',
							Image: require('./../assets/Colores/EscapeSEL/NegroAgata.webp'),
						},
					],
				},

				'BRONCO SPORT WILDTRAK': {
					Colors: [
						{
							Name: 'NARANJA METÁLICO',
							NName: 'NARANJA METÁLICO',
							Hexa: '#F59A02',
							HexaAlt: '#AA6E0B',
							Image: require('./../assets/Colores/BroncoWT/NaranjaMetalico.webp'),
						},
						/*{
                            "Name":"AZUL GLACIAR",
                            "Hexa":"#00708F",
                            "HexaAlt":"#065F78",
                            "Image":require('./../assets/Colores/BroncoWT/AzulGlaciar.webp')
                        },*/
						{
							Name: 'ROJO METÁLICO',
							NameAlt: 'ROJO METÁLICO',
							Hexa: '#AD0D27',
							HexaAlt: '#901025',
							Image: require('./../assets/Colores/BroncoWT/RojoMetalico.webp'),
						},
						{
							Name: 'GRIS CARBÓN',
							NameAlt: 'GRIS CARBÓN',
							Hexa: '#645D5D',
							HexaAlt: '#4B4746',
							Image: require('./../assets/Colores/BroncoWT/GrisCarbon.webp'),
						},
						{
							Name: 'PLATA PURO',
							Hexa: '#9C9E9F',
							HexaAlt: '#828486',
							Image: require('./../assets/Colores/BroncoWT/PlataPuro.webp'),
						} /*,
                        {
                            "Name":"BLANCO OXFORD",
                            "Hexa":"#F2F2F2",
                            "HexaAlt":"#BBBBBB",
                            "Image":require('./../assets/Colores/BroncoWT/BlancoOxford.webp')
                        },
                        {
                            "Name":"NEGRO SOMBRA",
                            "Hexa":"#030303",
                            "HexaAlt":"#030303",
                            "Image":require('./../assets/Colores/BroncoWT/NegroSombra.webp')
                        },*/,
					],
				},

				'BRONCO SPORT BIG BEND': {
					Colors: [
						{
							Name: 'AZUL METÁLICO',
							NameAlt: 'AZUL METÁLICO',
							Hexa: '#2D403E',
							HexaAlt: '#2C393C',
							Image: require('./../assets/Colores/BroncoBB/AzulMetalico.webp'),
						},
						{
							Name: 'ROJO METÁLICO',
							NameAlt: 'ROJO METÁLICO',
							Hexa: '#AD0D27',
							HexaAlt: '#901025',
							Image: require('./../assets/Colores/BroncoBB/RojoMetalico.webp'),
						},
						{
							Name: 'GRIS CARBÓN',
							NameAlt: 'GRIS CARBÓN',
							Hexa: '#645D5D',
							HexaAlt: '#4B4746',
							Image: require('./../assets/Colores/BroncoBB/GrisCarbon.webp'),
						},
						{
							Name: 'PLATA PURO',
							Hexa: '#9C9E9F',
							HexaAlt: '#828486',
							Image: require('./../assets/Colores/BroncoBB/PlataPuro.webp'),
						} /*,
                        {
                            "Name":"BLANCO OXFORD",
                            "Hexa":"#F2F2F2",
                            "HexaAlt":"#BBBBBB",
                            "Image":require('./../assets/Colores/BroncoBB/BlancoOxford.webp')
                        },
                        {
                            "Name":"NEGRO SOMBRA",
                            "Hexa":"#030303",
                            "HexaAlt":"#030303",
                            "Image":require('./../assets/Colores/BroncoBB/NegroSombra.webp')
                        },*/,
					],
				},

				'BRONCO SPORT OUTER BANKS': {
					Colors: [
						{
							Name: 'AZUL METÁLICO',
							NameAlt: 'AZUL METÁLICO',
							Hexa: '#2D403E',
							HexaAlt: '#2C393C',
							Image: require('./../assets/Colores/BroncoBB/AzulMetalico.webp'),
						},
						{
							Name: 'GRIS HIELO',
							NameAlt: 'GRIS HIELO',
							Hexa: '#AD0D27',
							HexaAlt: '#901025',
							Image: require('./../assets/Colores/BroncoBB/BlancoOxford.webp'),
						},
						{
							Name: 'GRIS CARBÓN',
							NameAlt: 'GRIS CARBÓN',
							Hexa: '#645D5D',
							HexaAlt: '#4B4746',
							Image: require('./../assets/Colores/BroncoBB/GrisCarbon.webp'),
						},
						{
							Name: 'PLATA PURO',
							Hexa: '#9C9E9F',
							HexaAlt: '#828486',
							Image: require('./../assets/Colores/BroncoBB/PlataPuro.webp'),
						}
					],
				},

				'EDGE SEL': {
					Colors: [
						/* {
							Name: 'ROJO METÁLICO',
							NameAlt: 'ROJO METÁLICO',
							Hexa: '#AD0D27',
							HexaAlt: '#901025',
							Image: require('./../assets/Colores/EdgeSEL/RojoMetalico.webp'),
						}, */
						{
							Name: 'GRIS CARBÓN',
							NameAlt: 'GRIS CARBÓN',
							Hexa: '#645D5D',
							HexaAlt: '#4B4746',
							Image: require('./../assets/Colores/EdgeSEL/GrisCarbon.webp'),
						},
						/* {
							Name: 'AZUL OXFORD',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/EdgeSEL/AzulOxford.webp'),
						}, */
						{
							Name: 'BLANCO PLATINO',
							Hexa: '#F0F0F0',
							HexaAlt: '#DBDBDB',
							Image: require('./../assets/Colores/EdgeSEL/BlancoPlatino.webp'),
						},
						{
							Name: 'PLATA PURO',
							Hexa: '#9C9DA1',
							HexaAlt: '#828486',
							Image: require('./../assets/Colores/EdgeSEL/PlataPuro.webp'),
						},
						/* {
							Name: 'NEGRO AGATA',
							NameAlt: 'NEGRO ÁGATA',
							Hexa: '#242424',
							HexaAlt: '#000000',
							Image: require('./../assets/Colores/EdgeSEL/NegroAgata.webp'),
						}, */
					],
				},

				'EDGE ST': {
					Colors: [
						{
							Name: 'ROJO METÁLICO',
							NameAlt: 'ROJO METÁLICO',
							Hexa: '#AD0D27',
							HexaAlt: '#901025',
							Image: require('./../assets/Colores/EdgeST/RojoMetalico.webp'),
						},
						{
							Name: 'GRIS CARBÓN',
							NameAlt: 'GRIS CARBÓN',
							Hexa: '#645D5D',
							HexaAlt: '#4B4746',
							Image: require('./../assets/Colores/EdgeST/GrisCarbon.webp'),
						},
						{
							Name: 'AZUL PERFORMANCE',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/EdgeST/AzulPerformance.webp'),
						},
						{
							Name: 'BLANCO PLATINO',
							Hexa: '#F0F0F0',
							HexaAlt: '#DBDBDB',
							Image: require('./../assets/Colores/EdgeST/BlancoPlatino.webp'),
						},
						{
							Name: 'PLATA PURO',
							Hexa: '#9C9DA1',
							HexaAlt: '#828486',
							Image: require('./../assets/Colores/EdgeST/PlataPuro.webp'),
						},
						{
							Name: 'NEGRO AGATA',
							NameAlt: 'NEGRO ÁGATA',
							Hexa: '#242424',
							HexaAlt: '#000000',
							Image: require('./../assets/Colores/EdgeST/NegroAgata.webp'),
						},
					],
				},

				'EXPLORER XLT': {
					Colors: [
						{
							Name: 'GRIS MAGNETICO',
							NameAlt: 'GRIS MAGNÉTICO',
							Hexa: '#586066',
							HexaAlt: '#4C515A',
							Image: require('./../assets/Colores/ExplorerXLT/GrisMagnetico.webp'),
						},
						{
							Name: 'ROJO METÁLICO',
							NameAlt: 'ROJO METÁLICO',
							Hexa: '#AD0D27',
							HexaAlt: '#901025',
							Image: require('./../assets/Colores/ExplorerXLT/RojoMetalico.webp'),
						},
						{
							Name: 'AZUL OXFORD',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/ExplorerXLT/AzulOxford.webp'),
						},
						{
							Name: 'BLANCO PLATINO',
							Hexa: '#F0F0F0',
							HexaAlt: '#DBDBDB',
							Image: require('./../assets/Colores/ExplorerXLT/BlancoPlatino.webp'),
						},
						{
							Name: 'PLATA PURO',
							Hexa: '#9C9DA1',
							HexaAlt: '#828486',
							Image: require('./../assets/Colores/ExplorerXLT/PlataPuro.webp'),
						},
						{
							Name: 'NEGRO AGATA',
							NameAlt: 'NEGRO ÁGATA',
							Hexa: '#242424',
							HexaAlt: '#000000',
							Image: require('./../assets/Colores/ExplorerXLT/NegroAgata.webp'),
						},
					],
				},

				'EXPLORER LIMITED': {
					Colors: [
						{
							Name: 'ROJO METÁLICO',
							NameAlt: 'ROJO METÁLICO',
							Hexa: '#AD0D27',
							HexaAlt: '#901025',
							Image: require('./../assets/Colores/ExplorerLimited/RojoMetalico.webp'),
						},
						{
							Name: 'GRIS MAGNETICO',
							NameAlt: 'GRIS MAGNÉTICO',
							Hexa: '#586066',
							HexaAlt: '#4C515A',
							Image: require('./../assets/Colores/ExplorerLimited/GrisMagnetico.webp'),
						},
						{
							Name: 'AZUL OXFORD',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/ExplorerLimited/AzulOxford.webp'),
						},
						{
							Name: 'BLANCO PLATINO',
							Hexa: '#F0F0F0',
							HexaAlt: '#DBDBDB',
							Image: require('./../assets/Colores/ExplorerLimited/BlancoPlatino.webp'),
						},
						{
							Name: 'PLATA PURO',
							Hexa: '#9C9DA1',
							HexaAlt: '#828486',
							Image: require('./../assets/Colores/ExplorerLimited/PlataPuro.webp'),
						},
						{
							Name: 'NEGRO AGATA',
							NameAlt: 'NEGRO ÁGATA',
							Hexa: '#242424',
							HexaAlt: '#000000',
							Image: require('./../assets/Colores/ExplorerLimited/NegroAgata.webp'),
						},
					],
				},

				'EXPLORER ST': {
					Colors: [
						{
							Name: 'ROJO METÁLICO',
							NameAlt: 'ROJO METÁLICO',
							Hexa: '#AD0D27',
							HexaAlt: '#901025',
							Image: require('./../assets/Colores/ExplorerST/RojoMetalico.webp'),
						},
						{
							Name: 'GRIS CARBÓN',
							NameAlt: 'GRIS CARBÓN',
							Hexa: '#586066',
							HexaAlt: '#4C515A',
							Image: require('./../assets/Colores/ExplorerST/GrisCarbon.webp'),
						},
						{
							Name: 'AZUL OXFORD',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/ExplorerST/AzulOxford.webp'),
						},
						{
							Name: 'BLANCO PLATINO',
							Hexa: '#F0F0F0',
							HexaAlt: '#DBDBDB',
							Image: require('./../assets/Colores/ExplorerST/BlancoPlatino.webp'),
						},
						{
							Name: 'PLATA PURO',
							Hexa: '#9C9DA1',
							HexaAlt: '#828486',
							Image: require('./../assets/Colores/ExplorerST/PlataPuro.webp'),
						},
						{
							Name: 'NEGRO AGATA',
							NameAlt: 'NEGRO ÁGATA',
							Hexa: '#242424',
							HexaAlt: '#000000',
							Image: require('./../assets/Colores/ExplorerST/NegroAgata.webp'),
						},
					],
				},

				'EXPEDITION LIMITED': {
					Colors: [
						{
							Name: 'GRIS MAGNETICO',
							NameAlt: 'GRIS MAGNÉTICO',
							Hexa: '#586066',
							HexaAlt: '#4C515A',
							Image: require('./../assets/Colores/ExpeditionLimited/GrisMagnetico.webp'),
						},
						{
							Name: 'PLATA PURO',
							Hexa: '#9C9DA1',
							HexaAlt: '#828486',
							Image: require('./../assets/Colores/ExpeditionLimited/PlataPuro.webp'),
						},
						{
							Name: 'NEGRO AGATA',
							NameAlt: 'NEGRO ÁGATA',
							Hexa: '#242424',
							HexaAlt: '#000000',
							Image: require('./../assets/Colores/ExpeditionLimited/NegroAgata.webp'),
						},
					],
				},

				'MUSTANG MACH 1': {
					Colors: [
						{
							Name: 'BLANCO OXFORD',
							Hexa: '#F0F0F0',
							HexaAlt: '#DBDBDB',
							Image: require('./../assets/Colores/MustangMach1/BlancoOxford.webp'),
						},
						{
							Name: 'GRIS ACERO',
							Hexa: '#586066',
							HexaAlt: '#4C515A',
							Image: require('./../assets/Colores/MustangMach1/GrisAcero.webp'),
						},
						{
							Name: 'NARANJA METÁLICO',
							NName: 'NARANJA METÁLICO',
							Hexa: '#F59A02',
							HexaAlt: '#AA6E0B',
							Image: require('./../assets/Colores/MustangMach1/NaranjaMetalico.webp'),
						},
						{
							Name: 'NEGRO PROFUNDO',
							Hexa: '#242424',
							HexaAlt: '#000000',
							Image: require('./../assets/Colores/MustangMach1/NegroProfundo.webp'),
						},
					],
				},

				'MUSTANG GT PREMIUM': {
					Colors: [
						{
							Name: 'AZUL GALACTICO',
							NameAlt: 'AZUL GALÁCTICO',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/MustangGTPremium/AzulGalactico.webp'),
						},
						{
							Name: 'GRIS CARBÓN',
							NameAlt: 'GRIS CARBÓN',
							Hexa: '#586066',
							HexaAlt: '#4C515A',
							Image: require('./../assets/Colores/MustangGTPremium/GrisCarbon.webp'),
						},
						{
							Name: 'ROJO RALLY',
							Hexa: '#AD0D27',
							HexaAlt: '#901025',
							Image: require('./../assets/Colores/MustangGTPremium/RojoRally.webp'),
						},
					],
				},

				'RANGER XL': {
					Colors: [
						{
							Name: 'AZUL RELAMPAGO',
							NameAlt: 'AZUL RELÁMPAGO',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/RangerXL/AzulRelampago.webp'),
						},
						{
							Name: 'BLANCO ARTICO',
							NameAlt: 'BLANCO ÁRTICO',
							Hexa: '#F0F0F0',
							HexaAlt: '#DBDBDB',
							Image: require('./../assets/Colores/RangerXL/BlancoArtico.webp'),
						},
						{
							Name: 'GRIS MAGNETICO',
							NameAlt: 'GRIS MAGNÉTICO',
							Hexa: '#586066',
							HexaAlt: '#4C515A',
							Image: require('./../assets/Colores/RangerXL/GrisMagnetico.webp'),
						},
						{
							Name: 'NEGRO PERLADO',
							Hexa: '#242424',
							HexaAlt: '#000000',
							Image: require('./../assets/Colores/RangerXL/NegroPerlado.webp'),
						},
						{
							Name: 'PLATA METÁLICO',
							NameAlt: 'PLATA METÁLICO',
							Hexa: '#9EA4A9',
							HexaAlt: '#898B8F',
							Image: require('./../assets/Colores/RangerXL/PlataMetalico.webp'),
						},
						{
							Name: 'ROJO RUBI',
							NameAlt: 'ROJO RUBÍ',
							Hexa: '#AD0D27',
							HexaAlt: '#901025',
							Image: require('./../assets/Colores/RangerXL/RojoRubi.webp'),
						},
					],
				},

				'RANGER XLS DIESEL': {
					Colors: [
						{
							Name: 'AZUL RELAMPAGO',
							NameAlt: 'AZUL RELÁMPAGO',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/RangerXLS/AzulRelampago.webp'),
						},
						{
							Name: 'BLANCO ARTICO',
							NameAlt: 'BLANCO ÁRTICO',
							Hexa: '#F0F0F0',
							HexaAlt: '#DBDBDB',
							Image: require('./../assets/Colores/RangerXLS/BlancoArtico.webp'),
						},
						{
							Name: 'GRIS MAGNETICO',
							NameAlt: 'GRIS MAGNÉTICO',
							Hexa: '#586066',
							HexaAlt: '#4C515A',
							Image: require('./../assets/Colores/RangerXLS/GrisMagnetico.webp'),
						},
						{
							Name: 'NEGRO PERLADO',
							Hexa: '#242424',
							HexaAlt: '#000000',
							Image: require('./../assets/Colores/RangerXLS/NegroPerlado.webp'),
						},
						{
							Name: 'PLATA METÁLICO',
							NameAlt: 'PLATA METÁLICO',
							Hexa: '#9EA4A9',
							HexaAlt: '#898B8F',
							Image: require('./../assets/Colores/RangerXLS/PlataMetalico.webp'),
						},
						{
							Name: 'ROJO RUBI',
							NameAlt: 'ROJO RUBÍ',
							Hexa: '#AD0D27',
							HexaAlt: '#901025',
							Image: require('./../assets/Colores/RangerXLS/RojoRubi.webp'),
						},
					],
				},

				'RANGER RAPTOR': {
					Colors: [
						{
							Name: 'AZUL RELAMPAGO',
							NameAlt: 'AZUL RELÁMPAGO',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/RangerRaptor/AzulFordPerformance.webp'),
						},
						{
							Name: 'BLANCO ARTICO',
							NameAlt: 'BLANCO ÁRTICO',
							Hexa: '#F0F0F0',
							HexaAlt: '#DBDBDB',
							Image: require('./../assets/Colores/RangerRaptor/BlancoArtico.webp'),
						},
						{
							Name: 'GRIS PIEDRA',
							Hexa: '#586066',
							HexaAlt: '#4C515A',
							Image: require('./../assets/Colores/RangerRaptor/GrisPiedra.webp'),
						},
						{
							Name: 'NEGRO ABSOLUTO',
							Hexa: '#242424',
							HexaAlt: '#000000',
							Image: require('./../assets/Colores/RangerRaptor/NegroAbsoluto.webp'),
						},
						{
							Name: 'NARANJA METÁLICO',
							NameAlt: 'NARANJA METÁLICO',
							Hexa: '#AD0D27',
							HexaAlt: '#901025',
							Image: require('./../assets/Colores/F150Raptor/NaranjaMetalico.webp'),
						},
					],
				},

				'F-150 LARIAT SPORT': {
					Colors: [
						{
							Name: 'AZUL GALACTICO',
							NameAlt: 'AZUL GALÁCTICO',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/F150Lariat/AzulGalactico.webp'),
						},
						{
							Name: 'BLANCO OXFORD',
							Hexa: '#F0F0F0',
							HexaAlt: '#DBDBDB',
							Image: require('./../assets/Colores/F150Lariat/BlancoOxford.webp'),
						},
						{
							Name: 'GRIS CARBÓN',
							NameAlt: 'GRIS CARBÓN',
							Hexa: '#586066',
							HexaAlt: '#4C515A',
							Image: require('./../assets/Colores/F150Lariat/GrisCarbon.webp'),
						},
						{
							Name: 'ROJO MAGNETICO',
							NameAlt: 'ROJO MAGNÉTICO',
							Hexa: '#AD0D27',
							HexaAlt: '#901025',
							Image: require('./../assets/Colores/F150Lariat/RojoMetalico.webp'),
						},
					],
				},

				'F-150 XLT FHEV': {
					Colors: [
						{
							Name: 'PLATA PURO',
							Hexa: '#9EA4A9',
							HexaAlt: '#898B8F',
							Image: require('./../assets/Colores/F150Platinum/PlataPuro.webp'),
						},
						{
							Name: 'GRIS CARBÓN',
							NameAlt: 'GRIS CARBÓN',
							Hexa: '#9EA4A9',
							HexaAlt: '#898B8F',
							Image: require('./../assets/Colores/BroncoBB/GrisCarbon.webp'),
						},
						{
							Name: 'BLANCO OXFORD',
							Hexa: '#9EA4A9',
							HexaAlt: '#898B8F',
							Image: require('./../assets/Colores/BroncoWT/BlancoOxford.webp'),
						},
						{
							Name: 'ROJO METÁLICO',
							NameAlt: 'ROJO METÁLICO',
							Hexa: '#9EA4A9',
							HexaAlt: '#898B8F',
							Image: require('./../assets/Colores/EscapeHibrida/RojoMetalico.webp'),
						},
					],
				},

				'F-150 PLATINUM FHEV': {
					Colors: [
						{
							Name: 'AZUL METÁLICO',
							NameAlt: 'AZUL METÁLICO',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/F150Platinum/AzulMetalico.webp'),
						},
						{
							Name: 'NEGRO AGATA',
							NameAlt: 'NEGRO ÁGATA',
							Hexa: '#242424',
							HexaAlt: '#000000',
							Image: require('./../assets/Colores/F150Platinum/NegroAgata.webp'),
						},
						{
							Name: 'PLATA PURO',
							Hexa: '#9EA4A9',
							HexaAlt: '#898B8F',
							Image: require('./../assets/Colores/F150Platinum/PlataPuro.webp'),
						},
						{
							Name: 'GRIS CARBÓN',
							NameAlt: 'GRIS CARBÓN',
							Hexa: '#9EA4A9',
							HexaAlt: '#898B8F',
							Image: require('./../assets/Colores/BroncoBB/GrisCarbon.webp'),
						}
					],
				},

				'F-150 RAPTOR': {
					Colors: [
						{
							Name: 'GRIS AZULADO',
							NameAlt: 'GRIS AZULADO',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/F150Raptor/GrisAzulado.png'),
						},
						{
							Name: 'BLANCO AVALANCHE',
							Hexa: '#F0F0F0',
							HexaAlt: '#DBDBDB',
							Image: require('./../assets/Colores/F150Raptor/BlancoOxford.webp'),
						},
						{
							Name: 'NEGRO AGATA',
							NameAlt: 'NEGRO ÁGATA',
							Hexa: '#242424',
							HexaAlt: '#000000',
							Image: require('./../assets/Colores/F150Raptor/NegroAgata.webp'),
						},
						{
							Name: 'NARANJA METÁLICO',
							NameAlt: 'NARANJA METÁLICO',
							Hexa: '#AD0D27',
							HexaAlt: '#901025',
							Image: require('./../assets/Colores/F150Raptor/NaranjaMetalico.webp'),
						},
					],
				},

				'RANGER FX4': {
					Colors: [
						{
							Name: 'BLANCO ARTICO',
							NameAlt: 'BLANCO ÁRTICO',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/RangerFX4/BlancoArtico.webp'),
						},
						{
							Name: 'GRIS MAGNETICO',
							NameAlt: 'GRIS MAGNÉTICO',
							Hexa: '#F0F0F0',
							HexaAlt: '#DBDBDB',
							Image: require('./../assets/Colores/RangerFX4/GrisMagnetico.webp'),
						},
						{
							Name: 'NEGRO PERLADO',
							Hexa: '#586066',
							HexaAlt: '#4C515A',
							Image: require('./../assets/Colores/RangerFX4/NegroPerlado.webp'),
						},
						{
							Name: 'PLATA METÁLICO',
							NameAlt: 'PLATA METÁLICO',
							Hexa: '#586066',
							HexaAlt: '#4C515A',
							Image: require('./../assets/Colores/RangerFX4/PlataMetalico.webp'),
						},
						{
							Name: 'ROJO RUBI',
							NameAlt: 'ROJO RUBÍ',
							Hexa: '#586066',
							HexaAlt: '#4C515A',
							Image: require('./../assets/Colores/RangerFX4/RojoRubi.webp'),
						},
					],
				},

				'RANGER LIMITED': {
					Colors: [
						{
							Name: 'AZUL RELAMPAGO',
							NameAlt: 'AZUL RELÁMPAGO',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/RangerXLS/AzulRelampago.webp'),
						},
						{
							Name: 'BLANCO ARTICO',
							NameAlt: 'BLANCO ÁRTICO',
							Hexa: '#F0F0F0',
							HexaAlt: '#DBDBDB',
							Image: require('./../assets/Colores/RangerXLS/BlancoArtico.webp'),
						},
						{
							Name: 'GRIS MAGNETICO',
							NameAlt: 'GRIS MAGNÉTICO',
							Hexa: '#586066',
							HexaAlt: '#4C515A',
							Image: require('./../assets/Colores/RangerXLS/GrisMagnetico.webp'),
						},
						{
							Name: 'NEGRO PERLADO',
							Hexa: '#586066',
							HexaAlt: '#4C515A',
							Image: require('./../assets/Colores/RangerXLS/NegroPerlado.webp'),
						},
						{
							Name: 'PLATA METÁLICO',
							NameAlt: 'PLATA METÁLICO',
							Hexa: '#586066',
							HexaAlt: '#4C515A',
							Image: require('./../assets/Colores/RangerXLS/PlataMetalico.webp'),
						},
						{
							Name: 'ROJO RUBI',
							NameAlt: 'ROJO RUBÍ',
							Hexa: '#586066',
							HexaAlt: '#4C515A',
							Image: require('./../assets/Colores/RangerXLS/RojoRubi.webp'),
						},
					],
				},

				'RANGER LIMITED BLACK EDITION': {
					Colors: [
						{
							Name: 'NEGRO NOCHE',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/RangerLimitedBlackEdition/NegroNoche.webp'),
						},
					],
				},

				'RANGER XL CHASIS': {
					Colors: [
						{
							Name: 'BLANCO ARTICO',
							NameAlt: 'BLANCO ÁRTICO',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/RangerXLChasis/BlancoArtico.webp'),
						},
						{
							Name: 'PLATA METÁLICO',
							NameAlt: 'PLATA METÁLICO',
							Hexa: '#F0F0F0',
							HexaAlt: '#DBDBDB',
							Image: require('./../assets/Colores/RangerXLChasis/PlataMetalico.webp'),
						},
					],
				},

				'RANGER XLT': {
					Colors: [
						{
							Name: 'AZUL RELAMPAGO',
							NameAlt: 'AZUL RELÁMPAGO',
							Hexa: '#1676B9',
							HexaAlt: '#105DA5',
							Image: require('./../assets/Colores/RangerXLS/AzulRelampago.webp'),
						},
						{
							Name: 'BLANCO ARTICO',
							NameAlt: 'BLANCO ÁRTICO',
							Hexa: '#F0F0F0',
							HexaAlt: '#DBDBDB',
							Image: require('./../assets/Colores/RangerXLS/BlancoArtico.webp'),
						},
						{
							Name: 'GRIS MAGNETICO',
							NameAlt: 'GRIS MAGNÉTICO',
							Hexa: '#586066',
							HexaAlt: '#4C515A',
							Image: require('./../assets/Colores/RangerXLS/GrisMagnetico.webp'),
						},
						{
							Name: 'NEGRO PERLADO',
							Hexa: '#586066',
							HexaAlt: '#4C515A',
							Image: require('./../assets/Colores/RangerXLS/NegroPerlado.webp'),
						},
						{
							Name: 'PLATA METÁLICO',
							NameAlt: 'PLATA METÁLICO',
							Hexa: '#586066',
							HexaAlt: '#4C515A',
							Image: require('./../assets/Colores/RangerXLS/PlataMetalico.webp'),
						},
						{
							Name: 'ROJO RUBI',
							NameAlt: 'ROJO RUBÍ',
							Hexa: '#586066',
							HexaAlt: '#4C515A',
							Image: require('./../assets/Colores/RangerXLS/RojoRubi.webp'),
						},
					],
				},

			},
		];
	},
};
